module.exports = __webpack_public_path__ + "static/media/screenshot-no-device-access.35bf7073.jpeg";